import { Injectable } from '@angular/core';
import { CommunicationService } from '../services/communication.service';
import { Observable } from 'rxjs';
import { ResetPasswordModel } from './reset-password.models';

@Injectable()
export class ResetPasswordService {
  constructor(private communicationService: CommunicationService) {}

  resetPassword(model: ResetPasswordModel): Observable<void> {
    const formData = new FormData();
    formData.append('token', model.token);
    formData.append('password1', model.password);
    formData.append('password2', model.repeatPassword);

    return this.communicationService.postData('emailverification/updatepsw', formData);
  }
}
